import { useVideoPlayer, VideoView } from "expo-video";
import React from "react";

type Props = {
  uri: string;
  position: "left" | "right";
};

const VideoMessage = React.memo((props: Props) => {
  const { uri } = props;
  const player = useVideoPlayer(uri);
  return (
    <VideoView
      crossOrigin="anonymous"
      player={player}
      fullscreenOptions={{ enable: true }}
      preload="none"
      className="overflow-hidden rounded-2xl w-full min-w-64 max-w-sm bg-background-900 relative aspect-video"
    />
  );
});

VideoMessage.displayName = "VideoMessage";

export default VideoMessage;
